module.exports = __webpack_public_path__ + "static/img/transactionRight.8c0044a9.png";